export default __webpack_public_path__ + "static/media/reports-6.88d1cbce.png";